import { render, staticRenderFns } from "./oneinfo.vue?vue&type=template&id=65be3bc8&scoped=true&"
import script from "./oneinfo.vue?vue&type=script&lang=js&"
export * from "./oneinfo.vue?vue&type=script&lang=js&"
import style0 from "./oneinfo.vue?vue&type=style&index=0&id=65be3bc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65be3bc8",
  null
  
)

export default component.exports